import type { ShipmentColumn } from '../../types/column-types'
import { statusColumn } from './status'
import { shipmentIdColumn } from './shipment-id'
import { marginRatioColumn } from './margin-ratio'
import { currencyRateColumn } from './currency-rate'
import { clientNameColumn } from './client-name'
import { labelNameColumn } from './label-name'
import { copiesColumn } from './copies'
import { quantityPerRollColumn } from './quantity-per-roll'
import { materialsColumn } from './materials'
import { createdAtColumn } from './created-at'
import { clientDeliveryDateColumn } from './client-delivery-date'
import { windingSchemesColumn } from './winding-schemes'
import { additionalInfoColumn } from './additional-info'
import { withoutCuttingColumn } from './without-cutting'
import { dealColumn } from './deal'
import { stampIdColumn } from './stamp-id'
import { stampWidthColumn } from './stamp-width'
import { stampLengthColumn } from './stamp-length'
import { stampFloodsColumn } from './stamp-floods'
import { stampRollerRollerColumn } from './stamp-roller-roller'
import { machineNameColumn } from './machine-name'
import { additionalMachinesColumn } from './additional-machines'
import { additionalJobsColumn } from './additional-jobs'
import { whitewashColumn } from './whitewash'
import { cmykColumn } from './cmyk'
import { pantonesColumn } from './pantones'
import { lacquersColumn } from './lacquers'
import { lacquersDmsColumn } from './lacquers-dms'
import { calculatedMaterialWidthColumn } from './calculated-material-width'
import { calculatedMaterialLengthColumn } from './calculated-material-length'
import { sellingPriceColumn } from './selling-price'
import { moneyGroupColumn } from './money-group'
import { consumablesGroupColumn } from './consumables-group'
import { timeGroupColumn } from './time-group'
import { calculatedLabelAreaColumn } from './label-area'
import { calculatedMaterialWeightColumn } from './material-weight'
import { paintCostOf1000DurstWGColumn } from './paint-cost-of-1000-durst-wg'
import { shipmentPositionActionsColumn } from './shipment-position-actions'
import { shipmentActionsColumn } from './shipment-actions'
import { numberOfFormsColumn } from './number-of-forms'
import { formSetColumn } from './form-set'

export const columns: ShipmentColumn[] = [
    statusColumn,
    shipmentIdColumn,
    additionalInfoColumn,
    marginRatioColumn,
    currencyRateColumn,
    clientNameColumn,
    materialsColumn,
    additionalJobsColumn,
    withoutCuttingColumn,
    stampIdColumn,
    stampWidthColumn,
    stampLengthColumn,
    stampFloodsColumn,
    stampRollerRollerColumn,
    machineNameColumn,
    additionalMachinesColumn,
    lacquersDmsColumn,
    whitewashColumn,
    cmykColumn,
    pantonesColumn,
    lacquersColumn,
    calculatedMaterialWidthColumn,
    calculatedMaterialLengthColumn,
    // labelNameColumn,
    copiesColumn,
    windingSchemesColumn,
    quantityPerRollColumn,
    numberOfFormsColumn,
    formSetColumn,
    createdAtColumn,
    clientDeliveryDateColumn,
    sellingPriceColumn,
    moneyGroupColumn,
    consumablesGroupColumn,
    timeGroupColumn,
    calculatedLabelAreaColumn,
    calculatedMaterialWeightColumn,
    paintCostOf1000DurstWGColumn,
    dealColumn,
    // shipmentPositionActionsColumn,
    shipmentActionsColumn,
]
